import { render } from "./SupplyAgreementTemplates.vue?vue&type=template&id=db9f3e3a&scoped=true"
import script from "./SupplyAgreementTemplates.vue?vue&type=script&lang=js"
export * from "./SupplyAgreementTemplates.vue?vue&type=script&lang=js"

import "./SupplyAgreementTemplates.vue?vue&type=style&index=0&id=db9f3e3a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db9f3e3a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTr,QToggle,QDialog,QCard,QCardSection,QBtn,QForm,QInput,QFile,QCheckbox,QCardActions});qInstall(script, 'directives', {ClosePopup});
